<template>
<!-- 支付计划设置组件 -->
  <div class="PaymentPlanSetup">
    <div>
      <QS-h4-title title="支付计划设置" />
    </div>
    <!-- 新增收款项 -->
    <div class="PaymentPlanSetup-setupBox">
      <div class="PaymentPlanSetup-setupBox-operation">
        <span class="label">{{`新增${receiveOrPayFlag?'付':'收'}款项：`}}</span>
        <el-select :disabled="adBtnDisabled" v-model="fundType" placeholder="请选择">
          <el-option
            v-for="item in rentOrderFeeList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="addPaymentPlan" :disabled="adBtnDisabled">添加</el-button>
      </div>
      <div class="PaymentPlanSetup-setupBox-info">
        <div class="startStopDate-box">
          <span>合同周期：</span>
          <span class="startStopDate">{{
            `${
              (startStopDate &&
                startStopDate[0] &&
                moment(startStopDate[0]).format('YYYY-MM-DD')) ||
              '-'
            }~${
              (startStopDate &&
                startStopDate[1] &&
                moment(startStopDate[1]).format('YYYY-MM-DD')) ||
              '-'
            }`
          }}</span>
        </div>
        <div class="daysOfLease-box">
          <span>
            租期共
            <span class="daysOfLease">{{
              (startStopDate &&
                startStopDate.length &&
                moment(startStopDate[1]).diff(startStopDate[0], 'day') + 1) ||
              0
            }}</span>
            天
          </span>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="PaymentPlanSetupFrom">
      <el-form ref="PaymentPlanSetupFrom" :model="tableDataFrom">
        <el-table class="add-table" :data="tableDataFrom.tableData">
          <el-table-column label="类型" width="100">
            <template slot-scope="scope">
              <el-form-item>
                <span>{{
                  scope.row.fundType | enumerationFilter(rentOrderFeeList)
                }}</span>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="`${receiveOrPayFlag?'付':'收'}款方式`" width="150">
            <template slot="header">
              {{`${receiveOrPayFlag?'付':'收'}款方式`}}
              <el-popover placement="top" width="500" trigger="hover">
                <span v-html="paymentMethodsTip"></span>
                <i slot="reference" class="el-icon-info icon-info"></i>
              </el-popover>
            </template>
            <!-- 收款项===租金&&租赁信息类别===司机合作模式 1-租金 3-司机合作模式 -->
            <template slot-scope="scope" v-if="!(scope.row.fundType === 1 && category === 3)">
              <el-form-item>
                <el-select
                  :disabled="scope.row.defaultFeeItem || scope.row.defaultTableData || scope.row.ladderSchemeDisabled"
                  size="small"
                  v-model="scope.row.payMode"
                  clearable
                  placeholder="请选择"
                  @change="rentPlanFeeTypeChange(scope.row)"
                >
                  <el-option
                    v-for="item in paymentMethodsList(scope.row)"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="阶梯" width="100">
            <template slot-scope="scope">
              <div class="ladder-box" v-if="scope.row.feeConfig && scope.row.feeConfig.feePiecewiseCalculation.isOpen == 1">
                <div class="ladder-item" v-for="(item, index) of scope.row.feeConfig && scope.row.feeConfig.feePiecewiseCalculation && scope.row.feeConfig.feePiecewiseCalculation.feePiecewiseConfigList || []" :key="index">
                  {{`${item.startMonth}至${item.endMonth}月`}}
                </div>
              </div>
              <span v-else >{{'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="金额" width="150">
            <template slot="header">
              金额
              <el-popover
                :content="moneyTip"
                placement="top"
                :width="350"
                trigger="hover"
              >
                <i slot="reference" class="el-icon-info icon-info"></i>
              </el-popover>
            </template>
            <template slot-scope="scope"  v-if="!(scope.row.fundType === 1 && category === 3)">
              <el-form-item>
                <div class="ladderAmount-box" v-if="scope.row.feeConfig && scope.row.feeConfig.feePiecewiseCalculation.isOpen">
                  <el-input
                    class="ladderAmount-item"
                    v-for="(item, index) of scope.row.feeConfig && scope.row.feeConfig.feePiecewiseCalculation && scope.row.feeConfig.feePiecewiseCalculation.feePiecewiseConfigList"
                    :key="index"
                    v-limit-money
                    placeholder="金额"
                    v-model="item.amount"
                    :disabled="(scope.row.payMode == 7 || scope.row.defaultFeeItem) || scope.row.ladderSchemeDisabled"
                    @input="unifiedChange(scope.row)"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </div>
                <el-input
                  v-else
                  placeholder="金额"
                  v-model="scope.row.planAmount"
                  :disabled="(scope.row.payMode == 7 || scope.row.defaultFeeItem) || scope.row.defaultTableData || scope.row.ladderSchemeDisabled"
                  @input="(val) => priceChange(val, scope.$index, scope.row)"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="缴款日" width="130">
            <template v-if="scope.row.payPost != 1 && !(scope.row.fundType === 1 && category === 3)" slot-scope="scope">
              <el-form-item
                v-if="scope.row.payMode == 3 || scope.row.payMode == 12"
                :prop="`tableData.${scope.$index}.payDay`"
              >
                <el-select
                  size="small"
                  v-model="scope.row.payDay"
                  clearable
                  placeholder="请选择"
                  @change="unifiedChange(scope.row)"
                >
                  <el-option
                    v-for="item in m_weekList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-else-if="scope.row.payMode != 6 && scope.row.payMode !== 7"
                :prop="`tableData.${scope.$index}.payDay`"
                :rules="m_rules.payDay"
              >
                <el-input
                  :disabled="scope.row.isStoreOrderDisabled"
                  v-interage="true"
                  @input="unifiedChange(scope.row)"
                  v-model="scope.row.payDay"
                  placeholder='1-31'
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="后置缴款" width="100">
            <template slot="header">
              后置缴款
              <el-popover
                :content="payPost"
                placement="top"
                :width="350"
                trigger="hover"
              >
                <i slot="reference" class="el-icon-info icon-info"></i>
              </el-popover>
            </template>
            <template slot-scope="scope" v-if="!(scope.row.fundType === 1 && category === 3)">
              <el-form-item v-if="scope.row.payMode != 6 && scope.row.payMode !== 7">
                <el-switch
                  :disabled="scope.row.isStoreOrderDisabled"
                  v-model="scope.row.payPost"
                  active-value="1"
                  inactive-value="0"
                  @change="payPostChange(scope.row)"
                >
                </el-switch>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="总期数" width="120">
            <template slot-scope="scope" v-if="!(scope.row.fundType === 1 && category === 3)">
              <el-form-item
                v-if="scope.row.totalCycle"
              >
                <span>{{ scope.row.totalCycle }}</span>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="`${receiveOrPayFlag?'付':'收'}款日期`" width="260">
            <template slot-scope="scope">
              <el-form-item v-if="scope.row.payMode == 6 && !(scope.row.fundType === 1 && category === 3)">
                <el-date-picker
                  v-model="scope.row.payDate"
                  type="date"
                  :clearable="false"
                  :disabled="scope.row.defaultTableData"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  @change="unifiedChange(scope.row)"
                >
                </el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <!--   仅租金下的“月付（自然月）、月付（满月）”付款方式，可以选择该选项，其他费项或付款方式，该选项处展示“- -” -->
          <el-table-column label="不足期日租金规则" width="260">
            <template slot-scope="scope">
              <el-form-item
                v-if="scope.row.fundType === 1 && (scope.row.payMode === 4 || scope.row.payMode === 5) && category !== 3"
                :prop="`tableData.${scope.$index}.dailyRule`"
              >
                <el-select
                  size="small"
                  v-model="scope.row.dailyRule"
                  clearable
                  placeholder="请选择"
                  @change="unifiedChange(scope.row)"
                  :disabled="scope.row.ladderSchemeDisabled"
                >
                  <el-option
                    v-for="item in dailyRentRules"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="发车前收款" width="260">
            <template slot-scope="scope">
              <el-form-item
                v-if="(scope.row.fundType === 1 || scope.row.fundType === 2) && !(scope.row.fundType === 1 && category === 3)"
                :prop="`tableData.${scope.$index}.advancePayment`"
              >
                <el-select
                  size="small"
                  v-model="scope.row.advancePayment"
                  clearable
                  placeholder="请选择"
                  @change="unifiedChange(scope.row)"
                  :disabled="scope.row.ladderSchemeDisabled || scope.row.advancePaymentDisabled"
                >
                  <el-option
                    v-for="(item) in filterAdvancePayment(advancePayment, scope.row)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="200">
            <template slot-scope="scope">
              <el-form-item>
                <el-input
                  maxlength="100"
                  show-word-limit
                  v-model="scope.row.remarks"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-form-item>
                <span
                  v-if="
                    scope.row.payMode &&
                    scope.row.totalCycle &&
                    (scope.row.payDay || scope.row.payPost == 1) &&
                    !(scope.row.fundType === 1 && category === 3) &&
                    !(scope.row.fundType === 1 && (scope.row.payMode === 4 || scope.row.payMode === 5) && typeof scope.row.dailyRule !== 'number') &&
                    !(scope.row.fundType === 1 && typeof scope.row.advancePayment !== 'number') &&
                    !(scope.row.fundType === 2 && typeof scope.row.advancePayment !== 'number') &&
                    isAmount(scope.row)
                  "
                >
                  <el-button
                    v-if="scope.row.items && scope.row.items.length"
                    @click="showDialog(scope.row)"
                    class="success"
                    type="text"
                    size="small"
                  >
                    已确认账单
                  </el-button>
                  <el-button
                    v-else
                    @click="showDialog(scope.row)"
                    class="danger"
                    type="text"
                    size="small"
                  >
                    需确认账单
                  </el-button>
                </span>
                <el-button
                  v-if="!scope.row.defaultTableData && !scope.row.ladderSchemeDisabled"
                  type="text"
                  size="small"
                  @click="deletePaymentPlan(scope.$index)"
                >
                  删除
                </el-button>
            </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>
    <!-- 底部数据统计 -->
    <div class="amountTotal">
      <div>
        <span
          class="amountItem"
          v-for="item of m_bottomTotalDefaultList"
          :key="item.code"
        >
          {{ item.code | enumerationFilter(rentOrderFeeList) }}:
          <span v-thousand-separator="item.number" class="amount"></span>
          元
        </span>
      </div>
      <div v-if="totalList.length > 0 && totalSwitch">
        <span
          class="amountItem"
          v-for="item of totalOtherList"
          :key="item.code"
        >
          {{ item.code | enumerationFilter(rentOrderFeeList) }}:
          <span v-thousand-separator="item.number" class="amount"></span>
          元
        </span>
      </div>
      <el-button
        type="text"
        @click="() => (this.totalSwitch = !this.totalSwitch)"
        >{{ `${(totalSwitch && '收起') || '展开'}` }}</el-button
      >
      <div>
        <span>
          订单总计金额:
          <span v-thousand-separator="paymentPlanTotal" class="amount"></span>
          元
        </span>
      </div>
    </div>
    <PreviewRentOrder @confirmBill="getConfirmBill" ref="PreviewRentOrder"/>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import PreviewRentOrder from './PreviewRentOrder.vue'
import { calculateTotal, calculateCycle, cycleDetail } from '../config/calculator'
import configData from '../config'
import { limitMoreZero } from '@/utils/validate'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  name: 'PaymentPlanSetup',
  props: {
    startStopDate: {
      type: Array,
      default: () => [],
    },
    tableDataFrom: {
      type: Object,
      default: () => ({}),
    },
    category: {
      type: Number,
      default: () => 1, // 租赁信息中的类别  1-租车 2-以租代购 3-司机合作模式
    },
    receiveOrPayFlag: { // 组件中所有显示收款或付款的flag 默认为false为收款
      type: Boolean,
      default: false,
    },
    adBtnDisabled: { // 添加按钮禁用flag
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/no-unused-properties
    componentsIsReady: { // 组件准备好的事件通知回调
      type: Function,
      default: () => null,
    },
  },
  provide() {
    return {
      receiveOrPayFlag: this.receiveOrPayFlag,
    }
  },
  data() {
    const {
      m_bottomTotalDefaultList, // 支付计划底部统计默认展示列表
      m_rules, // 支付计划校验
      m_weekList, // 周付 缴款日下拉列表
    } = configData.call(this)

    return {
      m_bottomTotalDefaultList,
      m_rules,
      m_weekList,
      moment,
      totalSwitch: false,
      fundType: '', // 收款项
      totalList: [], // 统计结果
      startStopDateTimer: null, // 收款起止日期节流
      fundTypeTimer: null, // 收款项节流
      whetherRepeatTimer: null, // 收款项重复校验节流
    }
  },
  watch: {
    // 统计
    'tableDataFrom.tableData': {
      handler(val) {
        this.totalList = []
        this.totalList = calculateTotal(val)
        // 给默认展示的列表赋值
        this.m_bottomTotalDefaultList.forEach((item) => {
          item.number = 0
        })
        this.totalList.forEach((item) => {
          this.m_bottomTotalDefaultList.forEach((defaulItem) => {
            if (defaulItem.code === Number(item.code)) {
              defaulItem.number = item.number
            }
          })
        })
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      rentOrderFeeList: (state) => state.global.rentOrderFeeList, // 收款项
      // freeTypeList: (state) => state.global.freeTypeList, // 收款项
      paymentMethods: (state) => state.global.paymentMethods, // 付款方式
      paymentMethodsTip: (state) => state.global.paymentMethodsTip, // 付款方式hover提示
      moneyTip: (state) => state.global.moneyTip, // 金额hover提示
      payPost: (state) => state.global.payPost, // 后置缴款hover提示
      // eslint-disable-next-line vue/no-unused-properties
      presentDays: (state) => state.global.presentDays, // 赠送天数hover提示
    }),
    // 发车前收款
    advancePayment() {
      return this.dictParseList(selectOption.advancePayment)
    },
    // 日租金规则
    dailyRentRules() {
      return this.dictParseList(selectOption.dailyRentRules)
    },
    // 订单总金额计算
    paymentPlanTotal() {
      return (
        (this.totalList.length > 0 &&
          this.totalList.reduce((acc, cur) => {
            return acc + cur.number
          }, 0)) ||
        0
      )
    },
    // 底部展开的统计项
    totalOtherList() {
      return this.totalList.filter((item) => {
        return this.m_bottomTotalDefaultList.every((defaultItem) => {
          return defaultItem.code !== item.code
        })
      })
    },
  },
  components: {
    PreviewRentOrder,
  },
  // mixins: [addLeaseOrderMixin],
  async created() {
    Promise.all([
      this.$store.dispatch('getPaymentMethods', { type: 'rentOrderFeeType' }), // 获取收款项
      this.$store.dispatch('getPaymentMethods', { type: 'payMode' }), // 获取付款方式
    ]).then(() => {
      this.$emit('componentsIsReady') // 通知父组件，子组件已准备完毕，可使用
    }).catch((err) => {
      console.error('子组件获取基础数据异常，子组件将不可使用', err)
    })
  },
  filters: {
    // 枚举值
    enumerationFilter(val, list) {
      return (
        (list &&
          list.filter((item) => {
            return Number(item.code) === Number(val)
          })[0]?.name) ||
        ''
      )
    },
  },
  methods: {
    //   ○ 租金：
    //      ■ 付款方式为“一次性”，仅支持“收取全部”
    //      ■ 付款方式非“一次性”：
    //        ● 下拉控件展示，枚举值为“收取首期、发车前不收”，默认值为“收取首期”
    //   ○ 押金：
    //      ■ 付款方式为“一次性”，仅支持“收取全部”
    //      ■ 付款方式非“一次性”：
    //        ● 仅支持“收取首期
    filterAdvancePayment(val, row) {
      let list = []
      const { payMode, fundType } = row
      if (payMode === 6) {
        list = val.slice(2, 3)
        return list
      }
      if (fundType === 2) {
        list = val.slice(1, 2)
        return list
      }
      if (payMode !== '') {
        list = val.slice(0, 2)
        return list
      }
      return list
    },
    // 阶梯金额是否为空判断
    isAmount(row) {
      const { feeConfig = {}, planAmount } = row
      const { feePiecewiseCalculation = {} } = feeConfig || {}
      const { isOpen = 0, feePiecewiseConfigList = [] } = feePiecewiseCalculation || {}
      // 没开启阶梯 不校验阶梯金额
      if (isOpen === 0) {
        return planAmount
      }
      return feePiecewiseConfigList.every((item) => item.amount && item.startMonth && item.endMonth)
    },
    // 监听金额变化
    priceChange(value, index, row) {
      limitMoreZero(value, (val) => {
        this.$set(this.tableDataFrom.tableData[index], 'planAmount', val)
      }, 9)
      this.unifiedChange(row)
    },
    // 付款方式 过滤掉司机合作模式
    paymentMethodsList(row) {
      const isZuCheOrYiZu = [1, 2].includes(this.category)
      if (row.fundType === 1) {
        if (isZuCheOrYiZu) {
          return this.paymentMethods.map((item) => {
            if (Number(item.code) === 3) return { ...item, name: '周付(满周)' }
            return item
          })
        }
        return this.paymentMethods
      }
      return this.paymentMethods.filter((item) => {
        return Number(item.code) !== 7
      })
    },
    // 表单重新计算总期数
    // eslint-disable-next-line vue/no-unused-properties
    FormCalculation() {
      this.tableDataFrom.tableData.forEach((item) => {
        this.unifiedChange(item)
      })
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData = [...this.tableDataFrom.tableData]
      this.$refs.PaymentPlanSetupFrom.validate()
    },
    // 确认账单返回值
    getConfirmBill(bill) {
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData = this.tableDataFrom.tableData.map((item) => {
        if (Number(bill.fundType) === item.fundType) {
          item.items = bill.items
          item.totalCycle = bill.items.length
          item.complete = true
        }
        return item
      })
    },
    //  show确认账单弹窗
    showDialog(row) {
      const { feeConfig, fundType, payMode, presentDays, payPost, payDay, planAmount, complete, items, dailyRule } = row
      // 计算期数详情
      const params = {
        dailyRule,
        paymentMethods: this.paymentMethods, // 支付方式枚举
        rentPlanFeeType: payMode, // 支付方式
        startTime: this.startStopDate[0], // 开始时间
        endTime: this.startStopDate[1], // 结束时间
        giveDays: presentDays, // 赠送天数
        delayPayFlag: payPost, // 是否后置缴款 - 周期详情额外添加
        payDay, // 缴款日 - 周期详情额外添加
        arrears: planAmount, // 金额 - 周期详情额外添加
        feeConfig, // 阶梯数据
        wholeMonth: true, // 若付款方式为自然月，是否按照首尾相加是足月的情况计算首尾月的付款金额
      }

      const bill = {
        fundType,
        payMode,
        planAmount,
        payDay,
        payPost,
        startStopDate: [moment(this.startStopDate[0]).format('YYYY-MM-DD'), moment(this.startStopDate[1]).format('YYYY-MM-DD')],
        items: ((complete && items && items.length) && items) || cycleDetail(params),
      }

      if (bill.items && bill.items.length === 0) {
        this.$message.warning('系统异常，金额计算有误，请重新填写提交')
        return
      }
      this.$refs.PreviewRentOrder.showDialog(bill)
    },
    // 缴款日改变
    payPostChange(row) {
      row.payDay = ''
      this.unifiedChange(row)
    },
    // 收款方式改变
    rentPlanFeeTypeChange(row) {
      console.log('收款方式改变----', row)
      const { payMode, payDate, fundType } = row

      // 发车前收款逻辑
      row.advancePayment = ''

      //   ○ 租金：
      //      ■ 付款方式为“一次性”，仅支持“收取全部”
      //      ■ 付款方式非“一次性”
      //        ● 下拉控件展示，枚举值为“收取首期、发车前不收”，默认值为“收取首期”
      if (payMode !== 6 && fundType === 1) {
        row.advancePayment = 1
      }

      //   仅租金下的“月付（自然月）、月付（满月）”付款方式，可以选择该选项，其他费项或付款方式，该选项处展示“- -”
      if (row.payMode !== 4 && row.payMode !== 5) {
        row.dailyRule = ''
      }

      // 特殊策略
      // 司机合作模式,金额需清空
      if (payMode === 7) {
        row.planAmount = ''
        // 清空缴款日、交款后置、赠送天数
        row.payDay = ''
        row.payPost = ''
        row.presentDays = ''
      }

      // 一次性付款
      if (payMode === 6) {
        // 清空缴款日、交款后置、赠送天数
        row.payDay = ''
        row.payPost = ''
        row.presentDays = ''
      }

      // 周付/自然周
      if (payMode === 3 || payMode === 12) {
        // 缴款日需要清空
        row.payDay = ''
      }

      // 兜底策略：如果是非一次性付清的方式，收款日期则需要清除
      if (payMode !== 6 && payDate) {
        // 因插件问题，不能直接赋值为空
        row.payDate = ''
      }

      // 表单change
      this.unifiedChange(row)
    },
    // 计算总期数
    calculatecCycle(row) {
      const { payMode, presentDays } = row
      const params = {
        paymentMethods: this.paymentMethods,
        rentPlanFeeType: payMode,
        giveDays: presentDays,
        startTime: this.startStopDate[0],
        endTime: this.startStopDate[1],
      }
      return calculateCycle(params).totalCycle
    },
    // 表单change
    unifiedChange(row) {
      // 缴款日去除前面的0
      if (row.payDay) {
        row.payDay = Number(row.payDay)
      }
      // 赠送天数去除前面的0
      if (row.presentDays) {
        row.presentDays = Number(row.presentDays)
      }
      // 租金和押金 发车前收款处理
      row.advancePaymentDisabled = false
      // 清空账单  重新确认
      row.items = []
      row.complete = false
      row.totalCycle = this.calculatecCycle(row) // 计算期数
      this.isComplete(row) // 判断是否完成
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData = [...this.tableDataFrom.tableData]
    },
    // 判断当前条是否为完成
    isComplete(row) {
      // 判断一次性付款是否填写完成
      /**
       * payMode：1-年付，2-半年一付,3-周付，4-月付（满月），5-月付（自然月），6-一次性，8-三月一付，9-30天一付
       * fundType：1-车款，2-押金，3-管理费，4-服务费，5-维保费用，参考接口：/admin/v1/vehicle/state/enum，页面路由地址：/car_to_lease/forRentSignContract/personalSignContract租赁设置步骤
       * advancePayment：0-发车前不收,1-收取首期,2-收取全部
       */
      if (row.payMode === 6 && this.isAmount(row) && row.payDate) {
        if ([1, 2].includes(row.fundType) && row.advancePayment === '') {
          row.complete = false
          return
        }
        row.complete = true
      }

      // 判断其他付款方式是否填写完成
      if (row.payMode !== 6 && row.items.length > 0) {
        row.complete = true
      }
      // 司机合作模式  金额置0
      if (row.payMode === 7) {
        row.complete = true
      }
    },
    // 删除支付计划
    deletePaymentPlan(index) {
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData.splice(index, 1)
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData = [...this.tableDataFrom.tableData]
    },
    // 添加支付计划
    addPaymentPlan() {
      if (!this.startStopDate || this.startStopDate.length <= 0) {
        if (!this.startStopDateTimer) { // 提示节流
          this.$message.warning('请先选择收款起止日期')
          this.startStopDateTimer = setTimeout(() => {
            this.startStopDateTimer = null
          }, 3000)
        }
        return
      }

      if (!this.fundType) {
        if (!this.fundTypeTimer) { // 提示节流
          this.$message.warning('请先选择收款项')
          this.fundTypeTimer = setTimeout(() => {
            this.fundTypeTimer = null
          }, 3000)
        }
        return
      }
      // 相同类型只允许添加一条
      const whetherRepeat = this.tableDataFrom.tableData.some((item) => {
        return Number(item.fundType) === this.fundType
      })
      if (whetherRepeat) {
        if (!this.whetherRepeatTimer) { // 提示节流
          this.$message.error('当前类型已添加，不可重复添加')
          this.whetherRepeatTimer = setTimeout(() => {
            this.whetherRepeatTimer = null
          }, 3000)
        }
        return
      }

      // （收款项===租金&&租赁信息类别===司机合作模式）？默认除类型显示为租金和备注（可编辑）外，其他字段均显示- - ：遵循原来的显示逻辑
      const params = {}
      if (this.fundType === 1 && this.category === 3) {
        params.complete = true
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData.push({
        fundType: this.fundType,
        items: [],
        payMode: '',
        feeConfig: {
          feePiecewiseCalculation: {
            isOpen: 0,
            feePiecewiseConfigList: [],
            unit: 1, // 1 月
          },
        },
        complete: false,
        dailyRule: '', // 不足月日租金规则
        advancePayment: '', // 发车前收款
        ...params,
      })
      // 清空选择收款项
      this.fundType = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px
}
.PaymentPlanSetup {
  .add-table {
    width: 100%;
  }
  .add-table {
    ::v-deep thead tr {
      background-color: #f7f8fa;
    }
  }
  .PaymentPlanSetupFrom {
    margin-top: 16px;
  }
  .PaymentPlanSetup-setupBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .PaymentPlanSetup-setupBox-operation {
      .label {
        font-weight: 500;
        color: #323233;
      }
    }
    .PaymentPlanSetup-setupBox-info {
      display: flex;
      align-items: center;
      .startStopDate-box {
        .startStopDate {
          font-weight: 600;
          font-size: 16px;
          color: #3d3d3d;
        }
      }
      .daysOfLease-box {
        margin-left: 30px;
        .daysOfLease {
          font-weight: 600;
          font-size: 16px;
          color: #3d3d3d;
        }
      }
    }
  }
  .amountTotal {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    .amountItem {
      margin-left: 10px;
    }
    .amount {
      font-weight: 500;
      font-size: 16px;
      color: #3d3d3d;
    }
  }
}
.ladder-box {
  .ladder-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 10px 0;
    white-space: nowrap;
  }
}
.ladderAmount-box {
  .ladderAmount-item {
    margin: 5px 0;
  }
}
.danger {
  color: #d40000;
}
.success {
  color: #09ad76;
}
#app .el-table ::v-deep thead tr th {
  border: none !important;
}
</style>
